import type { FC, ReactNode } from 'react'

import { FlaskConical } from 'lucide-react'
import { cn } from '@/lib/utils'

interface DemoBadgeProps {
    className?: string
    tone?: 'dark' | 'paper' | 'overlay'
}

/** Marks demonstration content so it is never mistaken for an official release. */
export const DemoBadge: FC<DemoBadgeProps> = ({ className, tone = 'dark' }): ReactNode => {
    return (
        <span
            className={cn(
                'inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-sans text-[0.6rem] font-semibold uppercase tracking-[0.16em]',
                tone === 'paper' && 'border border-burgundy/30 bg-burgundy/10 text-burgundy',
                tone === 'dark' && 'border border-gold/30 bg-gold/10 text-gold',
                tone === 'overlay' && 'border border-ivory/20 bg-obsidian/70 text-ivory backdrop-blur',
                className
            )}
            title='Demonstration content, to be replaced with official material'
        >
            <FlaskConical className='size-3' aria-hidden='true' />
            Demo
        </span>
    )
}

interface DemoNoticeProps {
    kind: string
    className?: string
}

export const DemoNotice: FC<DemoNoticeProps> = ({ kind, className }): ReactNode => {
    return (
        <div className={cn('flex items-start gap-3 rounded-lg border border-gold/25 bg-gold/[0.06] px-4 py-3 text-sm text-ivory/80', className)} role='note'>
            <FlaskConical className='mt-0.5 size-4 shrink-0 text-gold' aria-hidden='true' />
            <p>
                <span className='font-medium text-ivory'>Demonstration {kind}.</span>{' '}
                This sample shows how the page works. It is not an official release and will be replaced with real material from the admin panel.
            </p>
        </div>
    )
}
